/* bes-copy-trap.js — Neto script #125 re-implemented.
   When a visitor copies a substantial text selection from a non-checkout page,
   append an attribution line so pasted text links back to the source. */
(function () {
  document.addEventListener('copy', function (e) {
    try {
      var sel = window.getSelection ? String(window.getSelection()) : '';
      if (!sel || sel.length < 40) return; // only meaningful selections
      var url = window.location.href.split('#')[0];
      var suffix = '\n\nRead more at: ' + url;
      if (e.clipboardData) {
        e.clipboardData.setData('text/plain', sel + suffix);
        e.clipboardData.setData('text/html', sel + '<br><br>Read more at: <a href="' + url + '">' + url + '</a>');
        e.preventDefault();
      }
    } catch (err) { /* never break copy */ }
  });
})();
